import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { reload, loadPage, reset as resetPage } from "./staffSlice";
import {
  isEmployeeActive,
  loadRecord,
  reset,
} from "../../features/employeeDetails/employeeDetailsSlice";
import { reset as resetEmplyeeHouseVisits } from "../../features/employeeHouseVisits/employeeHouseVisitsSlice";
import EmployeeStatus from "../../components/tables/EmployeeStatus";
import { Modal, Dropdown, Button } from "antd";
import EmployeeCard from "../employees/employeeCard";
import ActionsTable from "../../components/templates/ActionsTable";
import EmployeeBranches from "../../components/tables/EmployeeBranches";
import Phone from "../../components/tables/Phone";
import Address from "../../components/tables/Address";
import FullName from "../../components/tables/FullName";
import Age from "../../components/tables/Age";
import ProffesionalTitle from "../../components/tables/ProffesionalTitle";
import AvatarComponent from "../../components/tables/AvatarComponent";
import Gender from "../../components/tables/Gender";
import NewEmployeeWizard from "./newEmployee/NewEmployeeWizard";
import { ReactComponent as EmployeesImg } from "../../assets/no-employees.svg";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useUserBranches } from "../../hooks/accessControl";
import { DownOutlined, PlusOutlined, SwapOutlined } from "@ant-design/icons";
import AssignEmployee from "../employees/components/AssignEmployee";
import ReplaceEmployee from "../employees/components/ReplaceEmployee";

const StaffList = (props) => {
  const { activeTab } = props;
  const dispatch = useDispatch();
  const userBranches = useUserBranches();
  const [visible, setVisible] = useState(false);
  let location = useLocation();
  const { page: staffPage } = useSelector((state) => state.staff);
  const { current, pageSize, total, items, filter, order } = staffPage;
  const loading = useSelector(
    (state) => state.pendingActions["staff/loadPage"]
  );
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeCardVisible, setEmployeetCardVisible] = useState(false);
  const [showScheduling, setShowScheduling] = useState(false);
  const [assignVisible, setAssignVisible] = useState(false);
  const [replaceVisible, setReplaceVisible] = useState(false);
  const isAdmin = location.pathname.includes("admin");

  const intl = useIntl();
  let { branchId } = useParams();

  useEffect(() => {
    if (activeTab === "staff_workers") {
      dispatch(loadPage({ current: 1, filter: filter, order, pageSize }));
      dispatch(resetEmplyeeHouseVisits());
    }
  }, [activeTab, dispatch]);

  const onTextChange = (e) => {
    dispatch(
      loadPage({
        current: 1,
        filter: { ...filter, freeText: e.target.value },
        order,
        pageSize,
      })
    );
  };

  const onAddClick = () => {
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const getEmployee = (id) => {
    const params = {
      id: id,
      branchId: branchId,
      admin: isAdmin,
    };
    dispatch(loadRecord(params));
  };

  const onShowEmployeeCardClicked = (record, show) => {
    setSelectedEmployee(record);
    setEmployeetCardVisible(true);
    setShowScheduling(show);
    if (show) {
      getEmployee(record.id);
    }
  };

  const onHideEmployeeCardModal = () => {
    setEmployeetCardVisible(false);
    dispatch(reset());
  };

  const handleMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        onAssignClicked(record, true);
        break;
      case "2":
        onReplaceClicked(record);
        break;
      default:
        break;
    }
  };

  const onAssignClicked = (record) => {
    setAssignVisible(true);
    setSelectedEmployee(record);
  };

  const hideAssign = () => {
    setAssignVisible(false);
    setSelectedEmployee(null);
    dispatch(reload());
  };

  const onReplaceClicked = (record) => {
    setReplaceVisible(true);
    setSelectedEmployee(record);
  };

  const hideReplace = () => {
    setReplaceVisible(false);
    setSelectedEmployee(null);
    dispatch(reload());
  };

  const tableItems = [
    {
      title: "avatar_url",
      render: AvatarComponent,
      width: "80px",
    },
    {
      title: "fullname",
      sortIndex: "surename",
      sorter: true,
      render: FullName,
      ellipsis: true,
      columnProps: {
        customUrlParam: { staff: true },
      },
    },
    {
      title: "professional_role_id",
      render: ProffesionalTitle,
      ellipsis: true,
    },
    {
      title: "status",
      render: EmployeeStatus,
      ellipsis: true,
      filters: [
        { text: <FormattedMessage id="app.forms.active" />, value: 1 },
        {
          text: <FormattedMessage id="app.forms.not_active" />,
          value: 2,
        },
        { text: <FormattedMessage id="app.forms.candidate" />, value: 3 },
      ],
    },
    {
      title: "accounting_info.number",
      responsive: ["xxl"],
      ellipsis: true,
      width: "140px",
    },
    {
      title: "local_id_number",
      responsive: ["xxl"],
      ellipsis: true,
      width: "140px",
    },
    {
      title: "age",
      responsive: ["xl"],
      render: Age,
      columnProps: { field: "birthday" },
      width: "100px",
      sortIndex: "birthday",
      sorter: true,
    },
    {
      title: "gender_id",
      responsive: ["xl"],
      render: Gender,
      width: "100px",
      filters: [
        {
          text: <FormattedMessage id="app.dataSelect.gender_id.male" />,
          value: 1,
        },
        {
          text: <FormattedMessage id="app.dataSelect.gender_id.female" />,
          value: 2,
        },
      ],
    },
    {
      title: "contact_info.mobile_number",
      render: Phone,
      width: "140px",
      ellipsis: true,
    },
    {
      title: "contact_info.phone_number",
      responsive: ["xxl"],
      render: Phone,
      width: "140px",
      ellipsis: true,
    },
    {
      title: "address",
      responsive: ["lg"],
      ellipsis: true,
      render: Address,
    },

    {
      title: "actions",
      responsive: ["md"],
      width: "120px",
      render: ({ record }) => (
        <div style={{ display: "flex" }}>
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  label: intl.formatMessage({
                    id: "app.employees.assignEmployee",
                  }),
                  key: "1",
                  icon: <PlusOutlined />,
                },
                {
                  label: intl.formatMessage({
                    id: "app.employees.replaceEmployee",
                  }),
                  key: "2",
                  icon: <SwapOutlined />,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
          >
            <Button type="link">
              {intl.formatMessage({
                id: "app.employees.options",
              })}
              <DownOutlined />
            </Button>
          </Dropdown>
        </div>
      ),
    },
  ];
  if (isAdmin) {
    tableItems.splice(2, 0, {
      title: "branches",
      render: EmployeeBranches,
      width: "120px",
      responsive: ["lg"],
      filters: userBranches.map((i) => ({ text: i.name, value: i.id })),
    });
  } else {
    tableItems.pop();
  }

  return (
    <div>
      <ActionsTable
        checkActive={(rec) => isEmployeeActive(rec)}
        tableItems={tableItems}
        ltrItems={["contact_info.mobile_number"]}
        category={"employees"}
        resource="employees"
        filtersType={{
          gender_id: "number",
          status: "number",
        }}
        current={current}
        pageSize={pageSize}
        total={total}
        loading={loading}
        textFilter={filter.freeText}
        order={order}
        paramsFilters={["branches"]}
        reload={reload}
        loadPage={loadPage}
        items={items}
        onTextChange={onTextChange}
        onAddClick={onAddClick}
        addbuttonText={
          <FormattedMessage id="app.employees.addNewStaffEmployee" />
        }
        headerInputPlaceholder={intl.formatMessage({
          id: "app.employees.typeEmployeeName",
        })}
        showheader={true}
        emptyImage={<EmployeesImg />}
        emptytext={<FormattedMessage id="app.tables.noEmployees" />}
        skipInitialLoad={true}
        resetPage={resetPage}
        autoFocus={true}
      />
      <Modal
        closable={false}
        maskClosable={false}
        footer={null}
        width={"820px"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        title={null}
        open={visible}
        onCancel={hide}
        destroyOnClose={true}
      >
        <NewEmployeeWizard
          hideWizard={hide}
          onShowEmployeeCardClicked={onShowEmployeeCardClicked}
        />
      </Modal>
      <EmployeeCard
        record={selectedEmployee}
        onHide={onHideEmployeeCardModal}
        visible={employeeCardVisible}
        showScheduling={showScheduling}
      />
      <AssignEmployee
        visible={assignVisible}
        hide={hideAssign}
        record={selectedEmployee}
      />
      <ReplaceEmployee
        visible={replaceVisible}
        hide={hideReplace}
        record={selectedEmployee}
      />
    </div>
  );
};

export default StaffList;
